import "./App.css";
import { Routes, Route } from "react-router-dom";
import Connexion from "./screens/Connexion";
import Home from "./screens/Home";
import Films from "./screens/Films";
import Dessins from "./screens/Dessins";
import Illustrations from "./screens/Illustrations";
import Animations from "./screens/Animations";
import Contact from "./screens/Contact";
import CreateWorkScreen from "./screens/CreateWork";
import ProtectedRoute from "./components/ProtectedRoute";

import { AuthProvider } from "./contexts/AuthContext";
import { WorkProvider } from "./contexts/WorkContext";

function App() {
  return (
    <AuthProvider>
      <WorkProvider>
        <Routes>
          <Route path="/login" element={<Connexion />} />
          <Route path="/" element={<Home />} />
          <Route path="/films" element={<Films />} />
          <Route path="/dessins" element={<Dessins />} />
          <Route path="/illustrations" element={<Illustrations />} />
          <Route path="/animations" element={<Animations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/CreateWork" element={
            <ProtectedRoute>
              <CreateWorkScreen /> 
            </ProtectedRoute>} 
          />
        </Routes>
      </WorkProvider>
    </AuthProvider>
  );
}

export default App;
